import { useContext } from 'react';

import { InventoryItem } from '@/components/Inventory/InventoryItem';
import { inventoryItemMinWidth, maxSlidesInInventorySlider } from '@/constants/inventory';
import { LayoutContext } from '@/contexts/LayoutContext';
import { getDefaultSort } from '@/tools/inventory';
import { SliderInventory } from '@lamesarv-sdk/inventory';
import { getSingleFilter } from '@lamesarv-sdk/tools';
import { Spinner } from '@lamesarv-sdk/components';

import { IInventory, InventoryField } from '@lamesarv-sdk/types';

export interface IDetailsSimilarRVsProps {
  item: IInventory;
}

export const DetailsSimilarRVs = ({ item }: IDetailsSimilarRVsProps) => {
  const { context } = useContext(LayoutContext);

  return (
    <div className="bg-neutral-100 px-4 md:px-6">
      <div className="container mx-auto py-8 px-4 md:px-16 flex flex-col gap-4">
        <h2 className="text-2xl font-bold tracking-wider text-sage-800">SIMILAR RVS</h2>
        {context.isGeoLocationLoading && (
          <div className="block">
            <Spinner className="w-6 h-6" />
          </div>
        )}
        {!context.isGeoLocationLoading && (
          <SliderInventory
            filters={getSingleFilter(InventoryField.body, item[InventoryField.body])}
            limit={10}
            sort={getDefaultSort(context)}
            geoLocation={context.geoLocation}
            CustomInventoryItem={InventoryItem}
            minSlideWidth={inventoryItemMinWidth}
            maxSlides={maxSlidesInInventorySlider}
          />
        )}
      </div>
    </div>
  );
};
